import {
  Alignment,
  AlignmentType,
  ILevelsOptions,
  INumberingOptions,
  LevelFormat,
} from "docx";
import { Paragraphs } from "types/Paragraph";

export const useExtractNumberingConfig = (paragraphs: Paragraphs) => {
  const mapListIdToLevels: any = {};

  for (var paragraph of paragraphs) {
    if (paragraph.formatting.isList && paragraph.formatting.listItemInfo) {
      if (!mapListIdToLevels[paragraph.formatting.listItemInfo.listId]) {
        mapListIdToLevels[paragraph.formatting.listItemInfo.listId] = {};
      }

      var alignment = AlignmentType.START;

      switch (paragraph.formatting.listItemInfo.bulletAlignment) {
        case "START":
          alignment = AlignmentType.START;
          break;
        case "CENTER":
          alignment = AlignmentType.CENTER;
          break;
        case "END":
          alignment = AlignmentType.END;
          break;
        case "LEFT":
        default:
          alignment = AlignmentType.LEFT;
          break;
      }

      const indent: any = {};

      if (
        paragraph.formatting.listItemInfo.indentFirstLine &&
        paragraph.formatting.listItemInfo.indentFirstLine.magnitude
      ) {
        indent.hanging =
          paragraph.formatting.listItemInfo.indentFirstLine.magnitude +
          paragraph.formatting.listItemInfo.indentFirstLine.unit.toLowerCase();
      }

      if (
        paragraph.formatting.listItemInfo.indentStart &&
        paragraph.formatting.listItemInfo.indentStart.magnitude
      ) {
        indent.left =
          paragraph.formatting.listItemInfo.indentStart.magnitude +
          paragraph.formatting.listItemInfo.indentStart.unit.toLowerCase();
      }

      const firstToken = paragraph.tokens[0];

      var format = undefined;

      if (paragraph.formatting.listItemInfo.glyphType != undefined) {
        format = useConvertGlyphTypeToLevelFormat(
          paragraph.formatting.listItemInfo.glyphType,
          paragraph.formatting.listItemInfo.glyphSymbol
        );
      }

      var text = undefined;
      if (paragraph.formatting.listItemInfo.glyphSymbol != undefined) {
        text = paragraph.formatting.listItemInfo.glyphSymbol;
      } else if (
        paragraph.formatting.listItemInfo.glyphFormat != undefined &&
        paragraph.formatting.listItemInfo.nestingLevel != undefined
      ) {
        text = paragraph.formatting.listItemInfo.glyphFormat.replace(
          /[0-1]/,
          `${paragraph.formatting.listItemInfo.nestingLevel + 1}`
        );
      }

      var startIndentation = undefined;

      if (paragraph.formatting.listItemInfo.nestingLevel != undefined) {
        startIndentation = `${
          paragraph.formatting.listItemInfo.nestingLevel * 36
        }pt`;
      }

      var paragraphFormatting: { [key: string]: any } = {};

      if (startIndentation != undefined) {
        paragraphFormatting.indent = {
          start: startIndentation,
        };
      }

      if (paragraph.formatting.lineSpacing != undefined) {
        paragraphFormatting.spacing = {
          line: paragraph.formatting.lineSpacing * 240,
        };
      }

      // If the text is empty or the format is empty, skip this one.
      if (format == undefined) {
        continue;
      }

      mapListIdToLevels[paragraph.formatting.listItemInfo.listId][
        paragraph.formatting.listItemInfo.nestingLevel
      ] = {
        level: paragraph.formatting.listItemInfo.nestingLevel,
        format: format,
        text: text,
        alignnment: alignment,
        style: {
          paragraph: paragraphFormatting,
          run: useConvertTokenToRunFormatting(
            paragraph.formatting.listItemInfo.formatting
          ),
        },
      };
    }
  }

  const configs: any[] = [];

  for (var id in mapListIdToLevels) {
    const option = {
      reference: id,
      levels: [] as any,
    };

    for (var level in mapListIdToLevels[id]) {
      option.levels.push(mapListIdToLevels[id][level]);
    }

    if (option.levels.length == 0) continue;

    configs.push(option);
  }

  return configs;
};
